import { BuilderComponentGroup } from '../types'

export const ContactUsDesignBlocks: BuilderComponentGroup = {
  id: 'contact-us',
  title: 'Contact Us',
  components: [
    // {
    //   compId: 'contact1',
    //   title: 'Contact 1',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact2',
    //   title: 'Contact 2',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact3',
    //   title: 'Contact 3',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact4',
    //   title: 'Contact 4',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact5',
    //   title: 'Contact 5',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact6',
    //   title: 'Contact 6',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    {
      compId: 'contact1',
      title: 'Contact 1',
      icon: 'CardTick24',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'contact2',
      title: 'Contact 2',
      icon: 'CardTick24',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'contact3',
      title: 'Contact 3',
      icon: 'CardTick24',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'contact4',
      title: 'Contact 4',
      icon: 'CardTick24',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    // {
    //   compId: 'contact5',
    //   title: 'Contact 5',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
    // {
    //   compId: 'contact6',
    //   title: 'Contact 6',
    //   icon: 'CardTick24',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
  ],
}
